import {connect} from 'react-redux';
import React from 'react';
import {showMap, showList} from '../actions';
import Text from '../containers/Text';

const MobileControls = ({onListClick, onMapClick, currentTab}) => {
  const className = active => `d-block full-width btn btn-${active ? '' : 'outline-'}primary`;

  return (
    <div className='mobile-controls container-fluid d-md-none'>
      <div className='row'>
        <div className='col p-0'>
          <button
            className={className(currentTab === 'list')}
            onClick={() => {
                onListClick();
                window.wts.push(['send', 'click', {linkId: 'Tab.Liste'}]); // Mobile Ansicht: bei Klick auf Tab Liste
            }}>
            <Text id='show-list'/>
          </button>
        </div>
        <div className='col p-0'>
          <button
            className={className(currentTab === 'map')}
            onClick={() => {
                onMapClick();
                window.wts.push(['send', 'click', {linkId: 'Tab.Karte'}]); // Mobile Ansicht: bei Klick auf Tab Karte
            }}>
            <Text id='show-map'/>
          </button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = ({currentTab}) => ({
  currentTab
});

const mapDispatchToProps = dispatch => ({
  onListClick: () => dispatch(showList()),
  onMapClick: () => dispatch(showMap())
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileControls)
